var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81836 5.72754H7.63653M7.63653 5.72754V10.8182M7.63653 5.72754C2.54563 10.0909 1.81836 15.9088 6.90926 20.2722",
    stroke: "black",
    strokeWidth: 0.727251
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0913,
    y: 5.54544,
    width: 10.5455,
    height: 3.27251,
    stroke: "#5E5E5E",
    strokeWidth: 1.09088
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9095,
    y: 11.18,
    width: 10.9091,
    height: 3.63613,
    stroke: "#9B9B9B",
    strokeWidth: 0.727251
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9095,
    y: 17.0003,
    width: 10.9091,
    height: 3.63613,
    stroke: "#9B9B9B",
    strokeWidth: 0.727251
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRowUpIcon);
export default __webpack_public_path__ + "static/media/add_row_up_icon.b0d58b24984c5eecacfa34cb45ad641a.svg";
export { ForwardRef as ReactComponent };